/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_FinalistsInputs */



/**
* | output |
* | --- |
* | "Finalists" |
*
* @param {Tfield_Decklists_FinalistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_finalists = /** @type {((inputs?: Tfield_Decklists_FinalistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_FinalistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finalistes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalistas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalistas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finalisti")
	return /** @type {LocalizedString} */ ("Finalists")
});